// -----------------------------------------------------------------------------
// Const
// -----------------------------------------------------------------------------

const SITE = {
  copyright: `© Sleepstation 2012–`,
}

export default SITE
